import $ from 'jquery';
import moment from 'moment';

/* eslint-disable func-names */

$.validator.addMethod('alphabetical', function (value, element) {
  return this.optional(element) || /^[A-Za-z\s]+$/.test(value);
}, 'Just letters please.');

$.validator.addMethod(
  'dateITA',
  function (value, element) {
    let check = false;
    let adata;
    let gg;
    let mm;
    let aaaa;
    let xdata;

    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      adata = value.split('/');
      gg = parseInt(adata[0], 10);
      mm = parseInt(adata[1], 10);
      aaaa = parseInt(adata[2], 10);
      xdata = new Date(Date.UTC(aaaa, mm - 1, gg, 12, 0, 0, 0));
      if (
        xdata.getUTCFullYear() === aaaa &&
        xdata.getUTCMonth() === mm - 1 &&
        xdata.getUTCDate() === gg
      ) {
        check = true;
      } else {
        check = false;
      }
    } else {
      check = false;
    }

    return this.optional(element) || check;
  },
  $.validator.messages.date,
);

$.validator.addMethod(
  'monthITA',
  function (value, element) {
    let check = false;
    let adata;
    let mm;
    let aaaa;
    let xdata;

    if (/^\d{2}\/\d{4}$/.test(value)) {
      adata = value.split('/');
      mm = parseInt(adata[0], 10);
      aaaa = parseInt(adata[1], 10);
      xdata = new Date(Date.UTC(aaaa, mm - 1));
      if (xdata.getUTCFullYear() === aaaa && xdata.getUTCMonth() === mm - 1) {
        check = true;
      } else {
        check = false;
      }
    } else {
      check = false;
    }
    return this.optional(element) || check;
  },
  $.validator.messages.date,
);

$.validator.addMethod(
  'afterDate',
  function (value, element, params) {
    if (params[0] === undefined) {
      return false;
    }

    const dateValue = moment(value, 'DD/MM/YYYY');
    const dateParam = moment(params[0], 'DD/MM/YYYY');

    return this.optional(element) || dateValue.isAfter(dateParam);
  },
  $.validator.format('The typed date is not after {0}'),
);

$.validator.addMethod(
  'beforeDate',
  function (value, element, params) {
    if (params[0] === undefined) {
      return false;
    }

    const dateValue = moment(value, 'DD/MM/YYYY');
    const dateParam = moment(params[0], 'DD/MM/YYYY');

    return this.optional(element) || dateValue.isBefore(dateParam);
  },
  $.validator.format('The typed date is not before {0}'),
);

$.validator.methods.email = function (value, element) {
  const emailTest = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
  return this.optional(element) || emailTest.test(value);
};

$.validator.addMethod(
  'extension',
  function (value, element, param) {
    const extensions = typeof param === 'string' ? param.replace(/,/g, '|') : 'png|jpe?g|gif';
    return this.optional(element) || value.match(new RegExp(`\\.(${extensions})$`, 'i'));
  },
  $.validator.format('Please enter a file with a valid extension.'),
);

$.validator.addMethod(
  'maxsize',
  function (value, element, param) {
    if (this.optional(element)) {
      return true;
    }

    if ($(element).attr('type') === 'file') {
      if (element.files && element.files.length) {
        for (let i = 0; i < element.files.length; i += 1) {
          if (element.files[i].size > param) {
            return false;
          }
        }
      }
    }

    return true;
  },
  $.validator.format('File size must not exceed {0} bytes each.'),
);

$.validator.addMethod(
  'minsize',
  function (value, element, param) {
    if (this.optional(element)) {
      return true;
    }

    if ($(element).attr('type') === 'file') {
      if (element.files && element.files.length) {
        for (let i = 0; i < element.files.length; i += 1) {
          if (element.files[i].size <= param) {
            return false;
          }
        }
      }
    }

    return true;
  },
  $.validator.format('File selected is too small ({0} bytes).'),
);

/* eslint-disable func-names */
